import { useEffect } from "react";

function goToKycHub() {
  const url = `${window.location.origin}/user_profile/kyc`;
  // _top navigates the outermost browsing context regardless of cross-origin nesting.
  window.open(url, "_top");
}

function KycSubmittedPage() {
  useEffect(() => {
    goToKycHub();
  }, []);

  return null;
}

export default KycSubmittedPage;
